import { Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '@qaroni-app/auth/types/user';
import { Company } from '@qaroni-app/company/types/company';
import { CompanyStatusEnum } from '@qaroni-app/company/types/company-status.enum';
import { ImagesConfig } from '@qaroni-core/config/app/images.config';

@Component({
  selector: 'qaroni-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  standalone: false,
})
export class MenuComponent {
  readonly user = input<User | null>(null);
  readonly companies = input<Company[]>([]);

  readonly visibleCompanies = computed(() => {
    if (!this.companies()) {
      return [];
    }

    return this.companies().filter(
      company => company.status !== CompanyStatusEnum.CREATED
    );
  });

  private router = inject(Router);

  get avatar() {
    return ImagesConfig.maleAvatar;
  }

  public goToInvitations(): string[] {
    return [`/invitations`];
  }

  public goToUserProfile(): string[] {
    return [`/profile`];
  }

  public goToLogout(): string[] {
    return [`/auth/logout`];
  }
}
